// @flow strict

import * as React from 'react';
import { v4 as uuid } from 'uuid';

export type Component = {
  name: string,
  type: string,
  props: Object,
  children: Array<Component>,
};

type PropTypes = {|
  components: Array<Component>,
|};

const Wrapper = (props: PropTypes) => {
  function renderComponents(components: Array<Component>) {
    return components.map((item: Component) => {
      const ComponentEl = global[item.type][item.name];
      let children;
      if (ComponentEl === undefined) {
        // eslint-disable-next-line no-console
        console.log(`Component ${item.type}.${item.name} is missing`);
        return null;
      }

      if (item.children) {
        children = renderComponents(item.children);
      } else if (item.props.children) {
        ({ children } = item.props);
      }

      return (
        <ComponentEl {...item.props} key={uuid()}>
          {children}
        </ComponentEl>
      );
    });
  }

  return <React.Fragment>{renderComponents(props.components)}</React.Fragment>;
};

export default Wrapper;
